import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as UserAPI from "@/api/user";
import { CommonResponse, isSuccess } from "@/api/response";
import { DeleteRequest } from "@/api/user/request";

const MODULE_NAME = "user/delete";

/**
 * ユーザー情報削除APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Delete extends VuexModule {
  // state
  commonResponse: CommonResponse = {} as CommonResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.commonResponse);
  }

  get getMessage() {
    return this.commonResponse.message;
  }

  // MutationActions
  @MutationAction
  async deleteOne(deleteRequest: DeleteRequest) {
    const commonResponse = await UserAPI.deleteOne(deleteRequest);
    return {
      commonResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      commonResponse: {} as CommonResponse
    };
  }
}

export default getModule(Delete);
